import { render, staticRenderFns } from "./AccompanyingSheetTemplate.vue?vue&type=template&id=3b20a734&scoped=true"
import script from "./AccompanyingSheetTemplate.vue?vue&type=script&lang=js"
export * from "./AccompanyingSheetTemplate.vue?vue&type=script&lang=js"
import style0 from "./AccompanyingSheetTemplate.vue?vue&type=style&index=0&id=3b20a734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20a734",
  null
  
)

export default component.exports